import styled from 'styled-components';
import { MOBILE_SLIDER_BREAKPOINT, SELECTORS } from '../../../constants/constants';

export const MobileSliderContainer = styled.div`
  ${SELECTORS} & {
    display: none;
  }
  @media (max-width: ${MOBILE_SLIDER_BREAKPOINT}) { 
    ${SELECTORS} & {
        display: block;
    }
  }
`;

export const MobileGamePictureContainer = styled.div`
  ${SELECTORS} & {
    padding: 20px;
    img{
      border-radius: 18px;
    }
  }
`;